import React from "react";

export default function ButtonOptionSelector({
  label,
  options,
  selectedClass,
  onChange,
  columns = 1,
  buttonStyle = {}
}) {
  const handleClick = (cls) => {
    onChange(cls === selectedClass ? "" : cls);
  };

  const getColumnStyle = () => ({
    width: `${100 / columns}%`,
    boxSizing: "border-box",
    padding: "4px"
  });

  return (
    <div
      style={{
        padding: 12,
        borderRadius: 8,
        border: "1px solid #E5E7EB",
        background: "#fff"
      }}
    >
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: "#1F2937",
          marginBottom: 12
        }}
      >
        {label}
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          margin: "-4px" // to counteract padding in children
        }}
      >
        {options.map((opt) => {
          const isSelected = selectedClass === opt.class;
          const appliedClass = `z-btn ${opt.class}`;

          return (
            <div
              key={opt.class}
              style={{
                ...getColumnStyle(),
                borderRadius: 8,
                boxShadow: isSelected ? "0 0 0 2px rgba(59, 130, 246, 0.5)" : "none",
                transition: "box-shadow 0.2s ease-in-out",
                cursor: "pointer"
              }}
              onClick={() => handleClick(opt.class)}
            >
              <button className={appliedClass} title={opt.name} style={buttonStyle}>
                {opt.name}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
